import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const customersAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomersCustomersView],
  restrictedBannersAllowed: true,
}

export const customersPrivacyRequestsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomersPrivacyRequestsModifyAccess],
  restrictedBannersAllowed: true,
}

export const guestManagementEnhancements: DomainAccessControlConfig = [
  {
    warehouseFeatureToggles: [FeatureToggle.GuestManagementEnhancements],
  },
  {
    minICPlatformVersion: ICPlatformVersion.r2024_06_0,
  },
]
